/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiAnalysisRunStatus {
    NEW = 'NEW',
    SCHEDULED = 'SCHEDULED',
    RUNNING = 'RUNNING',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED'
}


export function instanceOfInternalApiAnalysisRunStatus(value: any): boolean {
    for (const key in InternalApiAnalysisRunStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalApiAnalysisRunStatus, key)) {
            if (InternalApiAnalysisRunStatus[key as keyof typeof InternalApiAnalysisRunStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiAnalysisRunStatusFromJSON(json: any): InternalApiAnalysisRunStatus {
    return InternalApiAnalysisRunStatusFromJSONTyped(json, false);
}

export function InternalApiAnalysisRunStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAnalysisRunStatus {
    return json as InternalApiAnalysisRunStatus;
}

export function InternalApiAnalysisRunStatusToJSON(value?: InternalApiAnalysisRunStatus | null): any {
    return value as any;
}

export function InternalApiAnalysisRunStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiAnalysisRunStatus {
    return value as InternalApiAnalysisRunStatus;
}

